import { ViewportScroller } from '@angular/common';
import { Component } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal.service';
import { NativeSafeZoneService } from 'src/app/services/native-safe-zone.service';
import { Decimal } from 'decimal.js';
import * as CookieConsent from 'vanilla-cookieconsent';
import { NativeCheckService } from 'src/app/services/native-check.service';

@Component({
  selector: 'libero-client-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  public footerLinks: {
    translateKey: string,
    route?: string,
  }[] = [
    {
      translateKey: 'aboutBWM',
      route: '/about',
    },
    {
      translateKey: 'videos',
      route: '/videos',
    },
    {
      translateKey: 'consult',
    },
    {
      translateKey: 'dictionary',
      route: '/dictionary',
    },
    {
      translateKey: 'businessDay',
      route: '/calendar',
    },
    {
      translateKey: 'modelPortfolios',
      route: '/model-portfolios',
    },
    {
      translateKey: 'thematicPortfolios',
      route: '/thematic-portfolios',
    },
    {
      translateKey: 'ownStrategy',
      route: '/own-strategies',
    },
    {
      translateKey: 'aboutDip',
      route: '/about-dip',
    },
    {
      translateKey: 'blog',
      route: '/blog',
    },
    {
      translateKey: 'documents',
      route: '/documents',
    },
    {
      translateKey: 'howWeInvest',
      route: '/how-we-invest',
    },
  ];

  public currentYear = new Date().getFullYear();

  public get isNativeApp(): boolean {
    return this.nativeCheckService.isNativePlatform();
  }

  public get phoneActionsHeight(): number {
    return Decimal.sum(this.nativeSafeZoneService.paddings.bottom + 69).toNumber();
  }

  public constructor(
    private modalService: ModalService,
    private viewportScroller: ViewportScroller,
    public nativeSafeZoneService: NativeSafeZoneService,
    private nativeCheckService: NativeCheckService,
  ) { }

  public openModal(scrollTop?: true): void {
    if(scrollTop) {
      this.viewportScroller.scrollToPosition([0, 0]);
    }
    this.modalService.openConsultModal();
  }

  public reopenCookieModal(): void {
    CookieConsent.show(true);
  }
}
